export default __webpack_public_path__ + "src/assets/next-page-button.6bd3c8a9dca9f3136fb9bb83f86f0974.svg";